module.exports = __webpack_public_path__ + "static/media/mosorio.626063d7.jpg";